import { FilterType } from '../types/types';
import DOMPurify from 'dompurify';

interface FilterButtonType {
	handleClick: (category: string | null) => void;
	activeCategory: string | null;
	category: FilterType;
}

const Filter = ({ category, handleClick, activeCategory }: FilterButtonType) => {
	return (
		<button
			id={category?.id}
			className={`dynamic-news__filter ${activeCategory === category?.id ? 'active' : ''}`}
			onClick={() => {
				handleClick(category?.id);
			}}
			dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(category?.name) }}
		></button>
	);
};

export default Filter;
